function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var createResizeObserver = function createResizeObserver(_ref) {
  var callback = _ref.callback;
  var resizeObserver = new ResizeObserver(function (entries) {
    if (typeof callback === 'function') {
      var _iterator = _createForOfIteratorHelper(entries),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var entry = _step.value;
          var dimentions = {};
          /**
           * `contentRect` may one day be deprecated in favor of `contentBoxSize` (and
           * `borderBoxSize`). Recent versions of browsers have begun supporting these properties
           * with some slight variations in how the spec was interpreted.
           */

          if (entry.contentBoxSize) {
            // Firefox implements `contentBoxSize` as a single content rect, rather than an array
            var contentBoxSize = Array.isArray(entry.contentBoxSize) ? entry.contentBoxSize[0] : entry.contentBoxSize;
            dimentions.width = contentBoxSize.inlineSize; // width

            dimentions.height = contentBoxSize.blockSize; // height
          } else {
            dimentions.width = entry.contentRect.width; // width

            dimentions.height = entry.contentRect.height; // height
          } // Prevent invoking callback if width or height are `0`


          if (dimentions.width && dimentions.height) {
            callback(entry.target, dimentions);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  });

  var observe = function observe(node) {
    resizeObserver.observe(node);
  };

  var unobserve = function unobserve(node) {
    resizeObserver.unobserve(node);
  };

  var disconnect = function disconnect() {
    resizeObserver.disconnect();
  };

  return {
    disconnect: disconnect,
    observe: observe,
    unobserve: unobserve
  };
};

export { createResizeObserver };
